import { render, staticRenderFns } from "./SimilarTrianglesViz.vue?vue&type=template&id=3ff6a9ca&scoped=true"
import script from "./SimilarTrianglesViz.vue?vue&type=script&lang=js"
export * from "./SimilarTrianglesViz.vue?vue&type=script&lang=js"
import style0 from "./SimilarTrianglesViz.vue?vue&type=style&index=0&id=3ff6a9ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff6a9ca",
  null
  
)

export default component.exports